<div class="functie-selection-dialog">
    <div class="dialog-header">
        <h2 class="dialog-title">
            <mat-icon class="title-icon">{{ hasAtLeastOneFunction() ? 'work' : 'warning' }}</mat-icon>
            {{ getDialogTitle() }}
        </h2>
        <p class="dialog-subtitle">{{ getDialogMessage() }}</p>
    </div>

    <div class="dialog-content">
        <!-- Functions available for selection -->
        <div *ngIf="hasAtLeastOneFunction()" class="functions-selection">
            <div class="functions-list">
                <div *ngFor="let func of data.functions" class="function-option"
                    [class.selected]="selectedFunctionId === func.functie_id"
                    [class.disabled]="!func.functie_active_auth_core"
                    (click)="func.functie_active_auth_core && onFunctionSelect(func.functie_id)">

                    <div *ngIf="func.functie_active_auth_core" class="function-radio">
                        <mat-radio-button [value]="func.functie_id" [checked]="selectedFunctionId === func.functie_id"
                            (change)="onFunctionSelect(func.functie_id)" color="primary">
                        </mat-radio-button>
                    </div>

                    <div class="function-info">
                        <div class="function-main">
                            <span class="function-name">{{ func.functie_name }}</span>
                        </div>

                        <div class="function-status d-flex flex-row align-items-center gap-2" *ngIf="func.is_active">
                            <mat-icon>check_circle</mat-icon>
                            <span>Activă curent</span>
                        </div>

                        <div class="function-status disabled d-flex flex-row align-items-center gap-2"
                            *ngIf="!func.functie_active_auth_core">
                            <mat-icon>block</mat-icon>
                            <span>Dezactivată</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="selection-info">
                <mat-icon class="info-icon">info</mat-icon>
                <span>Funcția activă va fi utilizată pentru calcularea permisiunilor și afișarea datelor
                    relevante.</span>
            </div> -->
        </div>

        <!-- No functions available -->
        <div *ngIf="!hasAtLeastOneFunction()" class="no-functions-message">
            <div class="no-functions-content">
                <mat-icon class="warning-icon">warning_amber</mat-icon>
                <h3>Nicio funcție disponibilă</h3>
                <p>
                    Nu aveți nicio funcție alocată în sistem. Pentru a putea utiliza aplicația,
                    trebuie să contactați administratorul pentru a vă asigna cel puțin o funcție.
                </p>
                <div class="contact-info">
                    <mat-icon>contact_support</mat-icon>
                    <span>Contactați administratorul sistemului</span>
                </div>
            </div>
        </div>
    </div>

    <div class="dialog-actions">
        <div class="action-buttons">
            <button *ngIf="canCancel()" class="btn btn-light" type="button" mat-flat-button (click)="onCancel()"
                [disabled]="isSubmitting">
                <mat-icon>close</mat-icon>
                Anulare
            </button>

            <button *ngIf="hasAtLeastOneFunction()" class="btn btn-primary" type="button" mat-flat-button
                color="primary" (click)="onConfirm()" [disabled]="!selectedFunctionId || isSubmitting">
                <mat-icon *ngIf="!isSubmitting">check</mat-icon>
                <mat-spinner *ngIf="isSubmitting" diameter="20"></mat-spinner>
                {{ isSubmitting ? 'Se confirmă...' : 'Confirmă selecția' }}
            </button>

            <button *ngIf="!hasAtLeastOneFunction()" class="btn btn-primary" type="button" mat-flat-button
                color="primary" (click)="onCancel()">
                <mat-icon>close</mat-icon>
                Închide
            </button>
        </div>
    </div>

    <!-- Loading overlay -->
    <div class="loading-overlay" *ngIf="isSubmitting">
        <div class="spinner-container">
            <mat-spinner diameter="50"></mat-spinner>
            <h3 class="mt-2">Se setează funcția activă...</h3>
        </div>
    </div>
</div>